var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneMessaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 72,
    viewBox: "0 0 61 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4163 16.3309H28.6583C26.6863 16.3309 25.0758 17.9346 25.0758 19.8982L25.043 52.1346L32.2407 44.9673H57.4163C59.3883 44.9673 60.9988 43.3637 60.9988 41.4V19.9309C60.9988 17.9673 59.3883 16.3309 57.4163 16.3309ZM37.6308 32.4655H34.0484V28.8655H37.6308V32.4655ZM44.8285 32.4655H41.2461V28.8655H44.8285V32.4655ZM52.0263 32.4655H48.4438V28.8655H52.0263V32.4655Z",
    fill: "#B833CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2613 55.6364H5.75162V9.81818H40.2613V14.3673H46.0129V9.81818C46.0129 4.38545 41.6088 0 36.153 0H9.85991C4.4041 0 0 4.38545 0 9.81818V62.1818C0 67.6145 4.4041 72 9.85991 72H36.153C41.6088 72 46.0129 67.6145 46.0129 62.1818V46.5709H40.2613V55.6364ZM29.5797 65.4545H16.4332V62.1818H29.5797V65.4545Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMessaging);
export default __webpack_public_path__ + "static/media/phone-messaging.c86ae0c446649c6bdd4148f6a9e086b3.svg";
export { ForwardRef as ReactComponent };